import FloatingVue, { vTooltip } from 'floating-vue'
import 'floating-vue/dist/style.css'

function prepareTooltipOptions(options: any) {
  const { value } = options
  if (typeof value === 'function') {
    options.value = {
      content: () => Promise.resolve(value() || ''),
      loadingContent: ''
    }
  }
  return options
}

function tooltipBeforeMount(el: any, options: any) {
  return vTooltip.beforeMount(el, prepareTooltipOptions(options))
}

function tooltipUpdated(el: any, options: any) {
  return vTooltip.updated(el, prepareTooltipOptions(options))
}

export default defineNuxtPlugin((nuxtApp) => {
  // Setup floating vue.
  nuxtApp.vueApp.use(FloatingVue, {
    placement: 'top',
    delay: 0,
    distance: 10,
    container: 'body',
    boundary: undefined,
    autoHide: true,
    disposeTimeout: 5000,
    themes: {
      tooltip: {
        html: true,
        triggers: ['hover', 'focus'],
        hideTriggers: (triggers: any) => [...triggers, 'click'],
        loadingContent: '...',
        noAutoFocus: true
      },
      dropdown: {
        placement: 'bottom',
        delay: 0,
        triggers: ['click'],
        distance: 0,
        container: 'body',
        boundary: undefined,
        autoHide: true,
        handleResize: true
      }
    }
  })

  // Wrap tooltip to allow customizations
  nuxtApp.vueApp.directive('tooltip', {
    beforeMount: tooltipBeforeMount,
    updated: tooltipUpdated,
    beforeUnmount: vTooltip.beforeUnmount
  })
})
